// extracted by mini-css-extract-plugin
export default {"wrapper":"SupportingQuestion_wrapper__93VcF","question":"SupportingQuestion_question__IrIUh"};